import { useEffect, useState } from "react";

export function Countdown({ endsAt }: { endsAt: number }) {
  const [remaining, setRemaining] = useState(() => Math.max(1, Math.ceil((endsAt - Date.now()) / 1_000)));

  useEffect(function tickCountdown() {
    const timer = window.setInterval(() => {
      setRemaining(Math.max(1, Math.ceil((endsAt - Date.now()) / 1_000)));
    }, 100);
    return function stopCountdown() {
      window.clearInterval(timer);
    };
  }, [endsAt]);

  return (
    <div className="countdown-overlay" role="status" aria-live="assertive" aria-label={`La partida comienza en ${remaining}`}>
      <span>PREPARATE</span>
      <strong key={remaining}>{remaining}</strong>
    </div>
  );
}
